(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('walkme', ["troubleshooting", function (troubleshooting) {
        var initDone = false;
        return {
            init: function () {
                if (initDone) {
                    return;
                }
                if (troubleshooting.entityDebugEnabled()) {
                    (function () {
                        var walkme = document.createElement('script');
                        walkme.type = 'text/javascript';
                        walkme.async = true;
                        walkme.src = 'https://cdn.walkme.com/users/eeed7a61331742149fdfd4e2f2d8e593/test/walkme_eeed7a61331742149fdfd4e2f2d8e593_https.js';
                        var s = document.getElementsByTagName('script')[0];
                        s.parentNode.insertBefore(walkme, s);
                        window._walkmeConfig = { smartLoad: true };
                    }());
                } else {
                    (function () {
                        var walkme = document.createElement('script');
                        walkme.type = 'text/javascript';
                        walkme.async = true;
                        walkme.src = 'https://cdn.walkme.com/users/eeed7a61331742149fdfd4e2f2d8e593/walkme_eeed7a61331742149fdfd4e2f2d8e593_https.js';
                        var s = document.getElementsByTagName('script')[0];
                        s.parentNode.insertBefore(walkme, s);
                        window._walkmeConfig = { smartLoad: true };
                    }());
                }
                initDone = true;
            }
        };
    }]);
}());